// import Vue from 'vue'
// import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
        path:'/',
        redirect:'/index'
    },
    {
        path: '/index',
        name: 'index',
        component: () => import('../views/IndexView.vue')
    },
    {
        path: '/about',
        name: 'about',
        component: () => import('../views/AboutView.vue')
    },
    {
        path: '/product',
        name: 'product',
        component: () => import('../views/ProductView.vue'),
    },
    {
        path: '/product/:id',
        name: 'productDetail',
        component: () => import('../views/ProductDetailView.vue'),
    },
    {
        path: '/culture',
        name: 'culture',
        component: () => import('../views/CultureView.vue')
    },
    {
        path: '/jobs',
        name: 'jobs',
        component: () => import('../views/JobsView.vue')
    },
    {
        path: '/contact',
        name: 'contact',
        component: () => import('../views/ContactView.vue')
    },
]

const router = new VueRouter({
    routes
})

export default router
